import { createRouter as createTanstackRouter } from "@tanstack/react-router";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
export const createRouter = () => {
	const router = createTanstackRouter({
		routeTree,
		scrollRestoration: true,
		defaultPreloadStaleTime: 0,
	});

	if (!router.isServer) {
		void import("@sentry/tanstackstart-react").then((SentryClient) => {
			SentryClient.init({
				dsn: "https://35590892420e8d74af0d308dce1e577d@o4510690890088448.ingest.us.sentry.io/4511168517898240",
				sendDefaultPii: true,
				integrations: [
					SentryClient.tanstackRouterBrowserTracingIntegration(router),
					SentryClient.replayIntegration(),
				],
				tracesSampleRate: 1.0,
				replaysSessionSampleRate: 0.1,
				replaysOnErrorSampleRate: 1.0,
				enableLogs: true,
			});
		});
	}

	return router;
};

export const getRouter = () => createRouter();

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof createRouter>;
	}
}
